/*
round state
INIT("INIT"),
TRAINING("TRAINING"),
TRAINING_AGGREGATION("TRAINING_AGGREGATION"),
TRAINING_TIMEOUT("TRAINING_TIMEOUT"),
TRAINING_COMPLETED("TRAINING_COMPLETED"),
EVALUATION("EVALUATION"),
EVALUATION_AGGREGATION("EVALUATION_AGGREGATION"),
EVALUATION_TIMEOUT("EVALUATION_TIMEOUT"),
EVALUATION_COMPLETED("EVALUATION_COMPLETED"),
TEST("TEST"),
TEST_AGGREGATION("TEST_AGGREGATION"),
TEST_TIMEOUT("TEST_TIMEOUT"),
TEST_COMPLETED("TEST_COMPLETED"),
COMPLETED("COMPLETED"),
FAILED("FAILED"),
STOPPED("STOPPED"),
*/

import styles from './RoundListRow.module.css';
import useApi from '../../services/useApi';
import saveAs from 'file-saver';
import dateFormat from '../../utils/dateFormat';
import { useRecoilState } from 'recoil';
import { namespaceState, newTaskConfig } from '../../recoil/atoms';
import { useEffect } from 'react';

export default function RoundListRow({index,row,testIndex,onClickChange,roundOn}) {
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const handleRow=()=>{
        onClickChange(index)
    }

    const rowState=row.state?row.state.toLowerCase()=="test_aggregation"?"aggregation":row.state.toLowerCase():"init";
    // const modelId=row.state.aggregationModelId;

    const handleDownload=()=>{
        // modelRegistry
        useApi.get('/ngp/modelreg/mm/model/v1/task/model/download?taskId='+row.taskId+'&namespaceId='+nsState.id+'&roundNum='+row.roundNum
        ,{ responseType: 'blob'})
        .then((res)=>{
            saveAs(res.data, "taskId"+
            row.taskId.split("-")[0]+
            "_"+
            (row.roundNum!=testIndex?"roundNum"+String(row.roundNum).padStart(2,'0'):"roundTest") + 
            ".tflite");
        });
    }

    return(
        <div onClick={handleRow} className={`${styles["rounds-list-row"]} ${ roundOn==index && styles['rounds-list-row-on']}`}>
            <div className={`${styles['list-row-dot']} ${styles[`list-row-dot-${rowState}`]}`}></div>
            {(rowState=="training"||rowState=="aggregation"||rowState=="test"||rowState=="evaluation")&&<>
            <div className={`${styles['list-row-dot']} ${styles[`list-row-dot-${rowState}`]}`}style={{animationDelay:"300ms"}}></div>
            <div className={`${styles['list-row-dot']} ${styles[`list-row-dot-${rowState}`]}`}style={{animationDelay:"1200ms"}}></div>
            <div className={`${styles['list-row-dot']} ${styles[`list-row-dot-${rowState}`]}`}style={{animationDelay:"2400ms"}}></div>
            </>}
            <span className={`${styles['list-row-text']} 
                              ${rowState!="init"&& 
                              styles['list-row-text-completed']}`}>
                              {row.roundNum==testIndex?"Test":row.roundNum + " Round"}
            </span>
            {rowState=="completed" ? 
            <div className={styles['list-row-acc']}>
                <div className={styles['list-row-score']}>
                    <div className={styles['list-row-score-img']}></div>
                    <span>
                    { 
                    (row.roundNum!=testIndex)?
                        (row.evaluationResult==null?
                            "--":Object.entries(row.evaluationResult).length==0?
                                "Invalid": row.evaluationResult.outputs.accuracy!==undefined?
                                    "ACC "+row.evaluationResult.outputs.accuracy?.toFixed(3):"MAE "+row.evaluationResult.outputs.mae?.toFixed(3)
                        ):
                        (row.testResult==null?
                            "--":Object.entries(row.testResult).length==0?
                                "Invalid":row.testResult.outputs.accuracy!==undefined?
                                "ACC "+row.testResult.outputs.accuracy?.toFixed(3):"MAE "+row.testResult.outputs.mae?.toFixed(3)
                        )
                    } 
                    </span>
                </div>
                <div className={styles['list-row-time']}>
                    <div className={styles['list-row-time-img']}></div>
                    <span>{dateFormat(row.updatedTime).date.split(" ")[1]}</span>
                </div>
            </div>
            : rowState!="init" && <span className={styles['list-row-sub']}>{rowState}</span>}
            {row.roundNum!=testIndex&&<div className={rowState=="completed" && styles['list-row-download']} onClick={handleDownload}></div>}
        </div>
    )
}